import * as React from "react";
import { VssPersona } from "azure-devops-ui/VssPersona";
import "./Persona.Example.css";

const initialsIdentityProvider = {
    getDisplayName() {
        return "Lucy Booth";
    },
    getIdentityImageUrl(size: number) {
        return undefined;
    }
};

const imageIdentityProvider = {
    getDisplayName() {
        return "Rory Boisvert";
    },
    getIdentityImageUrl(size: number) {
        return require("./persona-male.png");
    }
};

export default class PersonaExample extends React.Component {
    public render() {
        return (
            <div className="flex-column">
                <div>
                    <p>Persona Initials:</p>
                    <div className="persona-content">
                        <VssPersona
                            identityDetailsProvider={initialsIdentityProvider}
                            size={"extra-extra-small"}
                        />
                        <VssPersona
                            identityDetailsProvider={initialsIdentityProvider}
                            size={"extra-small"}
                        />
                        <VssPersona
                            identityDetailsProvider={initialsIdentityProvider}
                            size={"extra-small-plus"}
                        />
                        <VssPersona
                            identityDetailsProvider={initialsIdentityProvider}
                            size={"small"}
                        />
                        <VssPersona
                            identityDetailsProvider={initialsIdentityProvider}
                            size={"small-plus"}
                        />
                        <VssPersona
                            identityDetailsProvider={initialsIdentityProvider}
                            size={"medium"}
                        />
                        <VssPersona
                            identityDetailsProvider={initialsIdentityProvider}
                            size={"medium-plus"}
                        />
                        <VssPersona
                            identityDetailsProvider={initialsIdentityProvider}
                            size={"large"}
                        />
                        <VssPersona
                            identityDetailsProvider={initialsIdentityProvider}
                            size={"extra-large"}
                        />
                    </div>
                </div>
                <div>
                    <p>Persona Image:</p>
                    <VssPersona identityDetailsProvider={imageIdentityProvider} size={"large"} />
                </div>
            </div>
        );
    }
}
